import * as types from "../actions/types/pos.types";

const initialState = {
    fetchVirtualPosTerminalsState: "idle",
    virtualPosTerminals: [],
    fetchPhysicalPosTerminalsState: "idle",
    physicalPosTerminals: [],
    fetchTerminalRequestsState: "idle",
    terminalRequests: [],
    fetchPhysicalPosTerminalCount: 0,
    terminalBalance: 0,
    sweepHistory: [],
    fetchSweepHistoryState: "idle",
    posOnboardingStatus: null,
    posOnboardingStatusState: "idle",
    posOnboardingStatusFetchCount: 0,
};

export const posReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_VIRTUAL_POS_TERMINALS_STARTED:
            return {
                ...state,
                fetchVirtualPosTerminalsState: "loading",
            };
        case types.FETCH_VIRTUAL_POS_TERMINALS_SUCCEEDED: {
            return {
                ...state,
                fetchVirtualPosTerminalsState: "success",
                virtualPosTerminals: action.payload,
            };
        }
        case types.FETCH_VIRTUAL_POS_TERMINALS_FAILED:
            return {
                ...state,
                fetchVirtualPosTerminalsState: "failed",
            };

        case types.FETCH_HARDWARE_POS_TERMINALS_STARTED:
            return {
                ...state,
                fetchPhysicalPosTerminalsState: "loading",
            };
        case types.FETCH_HARDWARE_POS_TERMINALS_SUCCEEDED: {
            return {
                ...state,
                fetchPhysicalPosTerminalsState: "success",
                physicalPosTerminals: action.payload,
                fetchPhysicalPosTerminalCount: state.fetchPhysicalPosTerminalCount + 1,
            };
        }

        case types.FETCH_HARDWARE_POS_TERMINALS_FAILED:
            return {
                ...state,
                fetchPhysicalPosTerminalsState: "failed",
            };

        case types.FETCH_HARDWARE_POS_REQUESTS_STARTED:
            return {
                ...state,
                fetchTerminalRequestsState: "loading",
            };
        case types.FETCH_HARDWARE_POS_REQUESTS_SUCCEEDED: {
            return {
                ...state,
                fetchTerminalRequestsState: "success",
                terminalRequests: action.payload,
            };
        }
        case types.FETCH_HARDWARE_POS_REQUESTS_FAILED:
            return {
                ...state,
                fetchTerminalRequestsState: "failed",
            };

        case types.FETCH_SWEEP_HISTORY_STARTED: {
            return {
                ...state,
                fetchSweepHistoryState: "loading",
            };
        }

        case types.FETCH_SWEEP_HISTORY_SUCCEEDED: {
            return {
                ...state,
                sweepHistory: action.payload,
                fetchSweepHistoryState: "success",
            };
        }

        case types.FETCH_SWEEP_HISTORY_FAILED: {
            return {
                ...state,
                fetchSweepHistoryState: "FAILED",
            };
        }

        case types.CHECK_POS_ONBOARDING_STATUS_STARTED: {
            return {
                ...state,
                posOnboardingStatusState: "loading",
            };
        }

        case types.CHECK_POS_ONBOARDING_STATUS_SUCCEEDED: {
            return {
                ...state,
                posOnboardingStatus: action.payload,
                posOnboardingStatusState: "success",
                posOnboardingStatusFetchCount: state.posOnboardingStatusFetchCount + 1,
            };
        }

        case types.CHECK_POS_ONBOARDING_STATUS_FAILED: {
            return {
                ...state,
                posOnboardingStatusState: "FAILED",
            };
        }

        default:
            return state;
    }
};
